<div class="dialog">
    <h6 mat-dialog-title>{{'Image Settings' | translate}}</h6>
    <div id="parent" mat-dialog-content>
            <!--            <div class="row">-->
            <div>
                <h5>{{'Zoom' | translate}}</h5>
                <mat-slider #zoomSlider (input)="imageOverlayService.changeZoom(zoomSlider.value)" [max]="1"
                            [min]="0.01"
                            [step]="0.01"
                            [value]="imageOverlayService.zoom"
                ></mat-slider>
            </div>
            <!--            </div>-->
            <!--            <div class="row">-->
            <div>
                <h5>{{'Opacity' | translate}}</h5>
                <mat-slider #opacitySlider (input)="imageOverlayService.changeOpacity(opacitySlider.value)"
                            [step]="0.01"
                            [value]="imageOverlayService.opacity" max="1"
                            min="0"
                ></mat-slider>
            </div>
        <!--            </div>-->
        <div id="rotation">
            <div class="rotationChild">
                <button (click)="imageOverlayService.rotate('left')" mat-raised-button>
                    <mat-icon>rotate_left</mat-icon>
                </button>
            </div>
            <div class="rotationChild">
                <button (click)="imageOverlayService.rotate('right')" mat-raised-button>
                    <mat-icon>rotate_right</mat-icon>
                </button>
            </div>
        </div>

        <br>
        <div>
            <mat-checkbox #btnMove (click)="imageOverlayService.toggleImageDrag()"
                          [checked]="checked">{{'Move Img' | translate}}</mat-checkbox>
        </div>
        <div>
            <mat-checkbox #btnLandmarks (change)="changeLandmarkVisibility($event)"
                          *ngIf="imageOverlayService.landmarksActive" [checked]="imageOverlayService.landmarksVisible">
                {{'Show Landmarks' | translate}}</mat-checkbox>
        </div>
        <div>
            <button mat-raised-button *ngIf="imageOverlayService.landmarksActive" (click)="imageOverlayService.realignLandmarks()">
                {{'Realign Landmarks' | translate}}
            </button>
            <button style="margin-left: 5px" (click)="imageOverlayService.openImageWizard()" [mat-dialog-close]="true" class="cancel-button"
                    color="primary"
                    mat-raised-button>
                {{'Open Wizard' | translate}}
            </button>
        </div>


        <mat-divider style="margin-top: 20px"></mat-divider>
        <div id="overlayBtn">
            <div>
                <button [mat-dialog-close]="false" class="ok-btn" mat-raised-button>{{'OK' | translate}}</button>
            </div>
            <div class="resets">
                <button (click)="imageOverlayService.posResetImg()" [mat-dialog-close]="true" color="primary"
                        mat-raised-button>
                    {{'Reset Img' | translate}}
                </button>
            </div>
            <div class="resets">

                <button (click)="imageOverlayService.deleteImage()" [mat-dialog-close]="true" color="warn"
                        mat-raised-button>
                    {{'Delete Img' |translate}}
                </button>
                </div>

            </div>


    </div>
</div>

